module.exports = __webpack_public_path__ + "img/retail_active.38e3f97f.png";